import { render, staticRenderFns } from "./FilterPrice.vue?vue&type=template&id=8b31c526"
import script from "./FilterPrice.vue?vue&type=script&lang=ts"
export * from "./FilterPrice.vue?vue&type=script&lang=ts"
import style0 from "./FilterPrice.vue?vue&type=style&index=0&id=8b31c526&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports